import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export type UserActivityUserTypeColor = Color.POSITIVE | Color.WARNING | Color.INFO | Color.GREY_600

export enum UserActivityUserTypeId {
  EMPLOYEE = 'employee',
  SALESMAN = 'salesman',
  API_USER = 'apiUser',
  HOTELIER = 'hotelier',
}

export class UserActivityUserType extends Codebook<UserActivityUserTypeId> {
  static readonly EMPLOYEE = new UserActivityUserType(
    UserActivityUserTypeId.EMPLOYEE,
    () => $t('Employee'),
    Color.INFO,
  )
  static readonly SALESMAN = new UserActivityUserType(
    UserActivityUserTypeId.SALESMAN,
    () => $t('Salesman'),
    Color.POSITIVE,
  )
  static readonly API_USER = new UserActivityUserType(
    UserActivityUserTypeId.API_USER,
    () => $t('API user'),
    Color.WARNING,
  )
  static readonly HOTELIER = new UserActivityUserType(
    UserActivityUserTypeId.HOTELIER,
    () => $t('Hotelier'),
    Color.GREY_600,
  )

  private constructor(
    public readonly id: UserActivityUserTypeId,
    public readonly name: () => string,
    public readonly color: UserActivityUserTypeColor,
  ) {
    super(id)
  }
}
